import { createContext, useContext, useEffect,useMemo, useState } from 'react';

const historyContext = createContext(null);

export const HistoryProvider = ({ children }) => {
  const [query, setQuery] = useState({});
  const [totalPush, setTotalPush] = useState(0);

  const initQuery = () => {
    const search = new URLSearchParams(window.location.search);
    const data = [...search.entries()].reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

    setQuery(data);
  };

  const pushQuery = (data = {}) => {
    const url = new URL(window.location.href);
    const search = new URLSearchParams(data).toString();

    setQuery(data);

    if (search) {
      url.search = search;
    }
    setTotalPush(totalPush + 1);
    window.history.pushState({ ...data }, '', url);
  };

  const updateQuery = (data = {}) => {
    const combinedQuery = {
      ...query,
      ...data,
    }

    pushQuery(combinedQuery);
  }

  const replace = (data, title, url) => window.history.replaceState(data, title, url);

  const go = (step = -1) => {
    window.history.go(step);
    setTotalPush((totalPush) => totalPush + step);
  };
  const back = () => {
    window.history.back();
    setTotalPush((totalPush) => totalPush - 1);
  }

  const onPopState = ({ state = {} }) => setQuery(state);

  useEffect(() => {
    window.addEventListener('popstate', onPopState);

    initQuery();

    return () => window.removeEventListener('popstate', onPopState);
  }, []);

  const value = useMemo(
    () => ({
      totalPush,
      pushQuery,
      updateQuery,
      back,
      replace,
      go,
      query,
    }),
    [query, totalPush]
  );

  return <historyContext.Provider value={value}>{children}</historyContext.Provider>;
};

export const useCtxHistory = () => useContext(historyContext);

export const withZippiaHistory = (C) => {
  const Component = (props) => {
    const zippiaHistory = useCtxHistory();

    return <C {...props} zippiaHistory={zippiaHistory} />;
  };

  Component.getInitialProps = C.getInitialProps;
  Component.__docgenInfo = C.__docgenInfo;

  return Component;
};
